import sec2Img1 from "../assets/quiz-img1.webp"
import sec2Img2 from "../assets/quiz-img2.webp"
import sec2Img3 from "../assets/quiz-img3.webp"
import sec2Img4 from "../assets/quiz-img4.webp"
import sec2Img5 from "../assets/quiz-img5.webp"
import sec2Img6 from "../assets/quiz-img6.webp"
import sec2Img7 from "../assets/quiz-img7.webp"

import "./QuizPage/Quiz.css"

import { Link, useLocation } from 'react-router-dom'
import logo from "../assets/financial-breed-images/logo.png"

import logo1 from "../assets/quiz-img1.webp"
import logo2 from "../assets/quiz-img2.webp"
import logo3 from "../assets/quiz-img3.webp"
import logo4 from "../assets/quiz-img4.webp"
import logo5 from "../assets/quiz-img5.webp"
import logo6 from "../assets/quiz-img6.webp"
import logo7 from "../assets/quiz-img7.webp"

import icon1 from "../assets/icon-employees.png"
import icon2 from "../assets/icon-company.png"
import icon3 from "../assets/icon-handshake.png"

import icon4 from "../assets/icon-check-shield-2.png"
import icon5 from "../assets/icon-professionals.png"
import icon6 from "../assets/icon-money-in-hand.png"

import image1 from "../assets/business-covid-shutdown.jpg"
import image2 from "../assets/irs-stimulus-programs.jpg"
import image3 from "../assets/frustrated-business-owner.jpg"
import lockImg from "../assets/lock-icon-sm.png"

import { useMediaQuery } from 'react-responsive'

import * as EmailValidator from 'email-validator';


function ResultPage() {
    const location = useLocation()
    const search = location.search; // could be '?foo=bar'
    const params = new URLSearchParams(search);
    const name = params.get('name'); // bar
    const amount = params.get('amount'); // bar

    const is425 = useMediaQuery({ query: '(max-width: 425px)' })
    const is768 = useMediaQuery({ query: '(max-width: 768px)' })
    const is1024 = useMediaQuery({ query: '(max-width: 1024px)' })
    const is992 = useMediaQuery({ query: '(max-width: 992px)' })
    const is1440 = useMediaQuery({ query: '(max-width: 1440px)' })



    function numberWithCommas(x) {
        // console.log(EmailValidator.validate("test@email.com"));
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return <>
        {/* Navbar */}
        <nav className="navbar navbar-expand-lg navbar-light quiz-navbar bg-white pb-md-3 mt-0 pt-2">
            <div className="container-fluid mx-sm-3">
                <a className="navbar-brand quiz-nav-brand mr-xs-0" href="/">
                    <img src={logo} alt="logo" className='img-fluid' />
                </a>
                {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button> */}
                <ul className="navbar-nav mb-2 mb-lg-0">
                    <li className="nav-item">
                        <a className="nav-link" id="removeSticky2" href="tel:+13073126819"><i className="fa-solid fa-phone mx-2"></i>(307)-312-6819</a>
                    </li>
                </ul>
            </div>
        </nav>


        {/* Section #1 */}
        <div className="sec1">
            <div className="row mx-0">
                <div className="col-12">
                    <p className="sec1-c1-p color1">{name} Your Results are in:</p>
                </div>

                <div className="col-md-6 col-sm-12">
                    <h4 className="color1 text-center mb-2">Status</h4>
                    <h2 className="color1 text-center mb-2 sec1-col2-h2">Pre-Qualified</h2>
                </div>
                <div className="col-md-6 col-sm-12">
                    <h4 className="color1 text-center mb-2">ERC Grant Estimate</h4>
                    {
                        (amount !== "" && amount !== "0" && amount !== null && typeof amount !== "understand") ?
                            <h2 className="color1 text-center mb-2 sec1-col2-h2">${numberWithCommas(amount)}</h2>
                            :
                            <h2 className="color1 text-center mb-2 sec1-col2-h2">$0</h2>
                    }
                </div>

                {
                    is768 && <p className="d343">Want to Learn Exactly How Much You Can Get, and Accurate Quote on Fees, and How to Get in Line? Call Our Team now:</p>
                }

                <div className="col-12 sec1-c4">
                    <button>
                        <i className="fa-solid fa-phone mx-2"></i>
                        <strong>Call Now</strong>
                        <a href="tel:+13073126819" style={{ textDecoration: "none", color: "#ffffff" }}> (307)-312-6819</a>                        {/* - (307)-312-6819 */}
                    </button>
                </div>


                {/* <div className="col-md-6 col-sm-12 sec1-c5">
                    <div className="box">
                        <iframe class="elementor-video-iframe" allowfullscreen="" title="vimeo Video Player" data-lazy-load="https://player.vimeo.com/video/782724957?color&amp;autopause=0&amp;dnt=true&amp;loop=0&amp;muted=0&amp;title=0&amp;portrait=0&amp;byline=0&amp;h=b65bb71227#t=" src="https://player.vimeo.com/video/782724957?color&amp;autopause=0&amp;dnt=true&amp;loop=0&amp;muted=0&amp;title=0&amp;portrait=0&amp;byline=0&amp;h=b65bb71227&amp;autoplay=1#t="></iframe>
                    </div>
                </div> */}
                <p className="text-center">
                    Click the button to give us a call, or pick up the call coming shortly from our team to learn
                </p>
                <div className="col-md-9 col-sm-12 sec1-c6 mx-auto">
                    <div>
                        <span className='icon-list2'>
                            <i className="far fa-check-circle"></i>
                        </span>
                        <span className="color1">Exactly How Much You Will Qualify For</span>
                    </div>
                    <div>
                        <span className='icon-list2'>
                            <i className="far fa-check-circle"></i>
                        </span>
                        <span className="color1">An Accurate Quote on Fees for Our Network of Accountants to Do Everything For You</span>
                    </div>
                    <div>
                        <span className='icon-list2'>
                            <i className="far fa-check-circle"></i>
                        </span>
                        <span className="color1">How to Officially Claim Your Spot in Line</span>
                    </div>
                </div>

            </div>
        </div>


        {/* Section #2 */}
        <div className="sec2 px-lg-5">
            {
                is1024 ?
                    <>
                        <div className="row">
                            <div className="sec2-c1 d-flex align-items-center">
                                <h2>$10M's</h2>
                                <h4>In Employee Retention Tax Credits Processed for Businesses Across the Country</h4>
                            </div>
                            <div className="sec2-c1 d-flex align-items-center">
                                <h2>$26k+&nbsp;</h2>
                                <h4>Payout possible for each employee, with no cap on max credit received</h4>
                            </div>
                            <div className="sec2-c1 d-flex align-items-center">
                                <h2>$200k&nbsp;</h2>
                                <h4>Average Credit Size per ERC Application</h4>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="row">
                            <div className="col-md-4 col-sm-12 sec2-c1">
                                <h2>$10,000,000s</h2>
                                <h4>In Employee Retention Tax Credits Processed for Businesses Across the Country</h4>
                            </div>
                            <div className="col-md-4 col-sm-12 sec2-c1">
                                <h2>$26,000+</h2>
                                <h4>Payout possible for each employee, with no cap on max credit received</h4>
                            </div>
                            <div className="col-md-4 col-sm-12 sec2-c1">
                                <h2>$200k</h2>
                                <h4>Average Credit Size per ERC Application</h4>
                            </div>
                        </div>
                    </>
            }
            <div className="container">
                <div className="row justify-content-center mx-0 w-100">
                    {
                        is425 === true ?
                            <>
                                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                    <div>
                                        <img src={logo1} alt="logo1" style={{ maxWidth: "100px", margin: "10px 5px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo2} alt="logo2" style={{ maxWidth: "100px", margin: "10px 5px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo3} alt="logo3" style={{ maxWidth: "100px", margin: "10px 5px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo4} alt="logo4" style={{ maxWidth: "100px", margin: "10px 5px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo5} alt="logo5" style={{ maxWidth: "100px", margin: "10px 5px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo6} alt="logo6" style={{ maxWidth: "100px", margin: "10px 5px", opacity: "0.5" }} />
                                    </div>
                                    <div>
                                        <img src={logo7} alt="logo7" style={{ maxWidth: "100px", margin: "10px 5px", opacity: "0.5" }} />
                                    </div>
                                </div>
                            </>
                            :
                            is768 === true ?
                                <>
                                    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                        <div>
                                            <img src={logo1} alt="logo1" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo2} alt="logo2" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo3} alt="logo3" style={{ maxWidth: "130px", margin: "10px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo4} alt="logo4" style={{ maxWidth: "130px", margin: "10px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo5} alt="logo5" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo6} alt="logo6" style={{ maxWidth: "150px", margin: "10px 10px", opacity: "0.5" }} />
                                        </div>
                                        <div>
                                            <img src={logo7} alt="logo7" style={{ maxWidth: "120px", margin: "10px 10px", opacity: "0.5" }} />
                                        </div>
                                    </div>
                                </>
                                :
                                is992 === true ?
                                    <>
                                        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                            <div>
                                                <img src={logo1} alt="logo1" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo2} alt="logo2" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo3} alt="logo3" style={{ maxWidth: "130px", margin: "30px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo4} alt="logo4" style={{ maxWidth: "130px", margin: "30px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo5} alt="logo5" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo6} alt="logo6" style={{ maxWidth: "150px", margin: "30px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo7} alt="logo7" style={{ maxWidth: "120px", margin: "30px 10px", opacity: "0.5" }} />
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div style={{ marginTop: "50px", display: "flex", justifyContent: "space-evenly" }}>
                                            <div>
                                                <img src={logo1} alt="logo1" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo2} alt="logo2" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo3} alt="logo3" style={{ maxWidth: "120px", margin: "0px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo4} alt="logo4" style={{ maxWidth: "120px", margin: "0px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo5} alt="logo5" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo6} alt="logo6" style={{ maxWidth: "130px", margin: "0px 10px", opacity: "0.5" }} />
                                            </div>
                                            <div>
                                                <img src={logo7} alt="logo7" style={{ maxWidth: "110px", margin: "0px 10px", opacity: "0.5" }} />
                                            </div>
                                        </div>
                                    </>
                    }
                </div>
            </div>
        </div>


        {/* sectionSix */}
        <section className='quiz-sectionSix' style={{ backgroundColor: "#f3fffe" }}>
            <div className="">
                <div className="row mx-auto">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-3">
                                <div className="icon asd6542">
                                    <div className="circle-icon circle-icon12">
                                        <img src={icon4} alt="" className='img-fluid' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-9">
                                <div className="textDiv">
                                    <h3>Conservative and Honest Numbers for “Sleep Well at Night” Audit Protection</h3>
                                    <p>You’ve worked too hard on your business to jeopardize anything with an IRS audit. Our network of CPAs are conservative with their numbers and calculations, so you’ll be above reproach against agents looking for audits. Unlike many other fly-by-night organizations, we have processed $10,000,000s in ERC Credits, and continue to have great relations with regulatory entities.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-3">
                                <div className="icon asd6542">
                                    <div className="circle-icon circle-icon12">
                                        <img src={icon5} alt="" className='img-fluid' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-9">
                                <div className="textDiv">
                                    <h3>Our Network of Licensed Accountants Do All The Hard Work</h3>
                                    <p>We have a network of registered accountants doing all of the work on your credit, from start to finish. They understand the ERC nuances, and make sure everything is done correctly, and will hold up to scrutiny for years to come.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-3">
                                <div className="icon asd6542">
                                    <div className="circle-icon circle-icon12">
                                        <img src={icon6} alt="" className='img-fluid' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-9">
                                <div className="textDiv">
                                    <h3>No Repayment, Personal Guarantee or Credit Check</h3>
                                    <p>Because this is a tax credit from the IRS, and not a loan, there is no collateral, personal guarantees or credit check required to receive the tax credit. If you choose to use one of our financing partners to get your money in as little as 30 days, traditional loan info is required. But if you wait the 7-9 months, there is no credit info required.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        {/* sectionWorks */}
        <section className='quiz-sectionWorks' data-aos="fade-up">
            <div className="row mx-0 justify-content-center text-center">
                <h2>How It Works</h2>
                <div className="col-lg-3 col-md-6 mb-4">
                    <div className="asdew45545">
                        <div className="icon mb-3">
                            <div className="circle-icon">
                                <h1>1</h1>
                            </div>
                        </div>
                        <div>
                            <h4>Take the Qualification Quiz</h4>
                            <em>60 Seconds</em>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-4">
                    <div className="asdew45545">
                        <div className="icon mb-3">
                            <div className="circle-icon">
                                <h1 style={{ textShadow: "0px 0px 10px rgb(0 0 0 / 30%)" }}>2</h1>
                            </div>
                        </div>
                        <div>
                            <h4>Fill Out Application (Online or Phone)</h4>
                            <em>60 Seconds</em>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-4">
                    <div className="asdew45545">
                        <div className="icon mb-3">
                            <div className="circle-icon">
                                <h1>3</h1>
                            </div>
                        </div>
                        <div>
                            <h4>Work With Our Team to Get Docs and Info</h4>
                            <em>60 Seconds</em>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-4">
                    <div className="asdew45545">
                        <div className="icon mb-3">
                            <div className="circle-icon">
                                <h1>4</h1>
                            </div>
                        </div>
                        <div>
                            <h4>Processing, Submission and Payment from IRS</h4>
                            <em>60 Seconds</em>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        {/* sectionFaq */}
        <section className='quiz-sectionFaq'>
            <div className="row mx-0 justify-content-center text-center">
                <h3>Frequently Asked Questions</h3>
                <ul className="buttons">
                    <li>
                        <a href="#qualificationCard">Qualification</a>
                    </li>
                    <li>
                        <a href="#taxCreditCard">Tax Credit</a>
                    </li>
                    <li>
                        <a href="#ourCompanyCard">Our Company</a>
                    </li>
                </ul>
            </div>
            <div className="container">
                <div className="row mx-0 w-100">
                    <div id='qualificationCard'>
                        <h2>Qualification</h2>
                        <div className="faq-card">

                            <div className="row mt-3 m-0 justify-content-center">
                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample1" aria-expanded="false" aria-controls="collapseExample">
                                                Can I qualify if I’m a 1099 contractor?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample1">
                                                Unfortunately no. This program is only for companies who paid W2 wages to non-owners.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
                                                Can I qualify if I don’t have any W2 employees?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample2">
                                                Unfortunately no. This program is only for companies who paid W2 wages to non-owners.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
                                                Can I qualify for ERC when I got a PPP loan?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample3">
                                                Yes! There are multiple quarters you can qualify for, even if you got a PPP loan. Unfortunately you can’t use the same covered time period that you used for PPP, which might reduce your ERC amount, but you can most definitely qualify for ERC.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
                                                What if my revenue went up in 2020 or 2021? Can I still qualify?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample4">
                                                Yes! It’s called the “Employee Retention” credit, not the “Revenue Reduction” credit. It’s intended to help out the businesses that kept people employed during the hard times of pandemic, so you can qualify even if your revenue went up. You’ll need to qualify using one of the other qualification checks though – shutdowns / mandates or supply chain disruption.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="false" aria-controls="collapseExample">
                                                How long is the ERC program open for?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample5">
                                                For most businesses this will be open into 2024 (unless they change the rules again). It’s open as long as you can file amended 941-X returns, which is the later of 3 years from the date you filed your original return, or 2 years from the date you paid the payroll tax.                                                </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="false" aria-controls="collapseExample">
                                                What if I have bad credit? Is there a credit check involved?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample6">
                                                It doesn’t matter, because this is not a loan – it’s a tax credit. There are no credit checks, collateral, or personal guarantees required.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample7" aria-expanded="false" aria-controls="collapseExample">
                                                Can I qualify for ERC if my business is now closed?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample7">
                                                Yes, there is a possibility. It depends on when the business closed.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mx-0 w-100">
                    <div id='taxCreditCard'>
                        <h2 style={{ marginTop: "30px" }}>Tax Credit</h2>
                        <div className="faq-card">
                            <div className="row mt-3 m-0 justify-content-center">

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample8" aria-expanded="false" aria-controls="collapseExample">
                                                What documents do I need to send you?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample8">
                                                To complete your tax credit, we’ll work with you and your CPA to get the following documents:
                                                <ul>
                                                    <li>Payroll Journals outlining all payments, deductions, contributions and taxes for each employee for each paycheck during your ERC eligibility period.</li>
                                                    <li>Filed 941, 943 or 944 payroll reports.</li>
                                                    <li>Profit and Loss Statements (P&Ls) for 2020 and 2021</li>
                                                    <li>Tax returns for 2020 and 2021</li>
                                                    <li>PPP Loan Forgiveness Application (if applicable)</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample9" aria-expanded="false" aria-controls="collapseExample">
                                                What if I didn’t pay that much in payroll taxes? Will the IRS actually send me a check?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample9">
                                                Yes! This is a “refundable” tax credit, so that means if the IRS actually owes you more than you paid, it will send you a check for the difference.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample10" aria-expanded="false" aria-controls="collapseExample">
                                                Do I need to repay the tax credit?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample10">
                                                Nope! There is nothing to repay with a tax credit. This is not a loan.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample11" aria-expanded="false" aria-controls="collapseExample">
                                                How long does it take to get my credit?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample11">
                                                We are generally telling clients between 7-9 months. We take a few weeks to do the work, and the IRS is variable in how long it’s taking to process, but we’re seeing in the 7-9 month range. We do have an option to get you access to a portion of your credit within 30 days.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample12" aria-expanded="false" aria-controls="collapseExample">
                                                When will the ERC funds run out?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample12">
                                                There is now set amount of funds set aside for this program, so there is no money that will run out! But you can only submit your amended payroll tax form for up to 3 years after initial filing. The IRS has also changed the rules on this program multiple times, so we recommend applying as soon as possible if you’re interested.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample13" aria-expanded="false" aria-controls="collapseExample">
                                                What if I have back taxes on my account with the IRS?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample13">
                                                If you owe back taxes on your account, the IRS will deduct the amount you owe in back taxes from the credit amount, and will pay you the difference.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample14" aria-expanded="false" aria-controls="collapseExample">
                                                Is the ERC credit taxable?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample14">
                                                The ERC credit is not actually considered taxable income for federal tax purposes. But what it might do is reduce your company’s deductible wage expenses by the tax credit amount, which will most likely increase your net profit, and therefore what you pay taxes on. Please provide the credit to your CPA or tax preparer for what to do.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample15" aria-expanded="false" aria-controls="collapseExample">
                                                Will I get in trouble with the IRS for filing?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample15">
                                                Absolutely not! The IRS created this program and doubled-down on making it easier and more lucrative for businesses, so they really want you to file and use it.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mx-0 w-100">
                    <div id='ourCompanyCard'>
                        <h2 style={{ marginTop: "30px" }}>Our Company</h2>
                        <div className="faq-card">
                            <div className="row mt-3 m-0 justify-content-center">

                                <div className="col-12 my-2 faq-list">
                                    <div className="faq-item">
                                        <div className="fa-questions">
                                            <p className="btn btn-primary " style={{ backgroundColor: "transparent", border: "none", color: "black", fontSize: "18px", margin: 0 }} type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample16" aria-expanded="false" aria-controls="collapseExample">
                                                How much do you charge?
                                            </p>
                                        </div>
                                        <div className="fa-answers">
                                            <div className="collapse" id="collapseExample16">
                                                Our fees are paid only after you receive your credit, and depend on the total number of employees, qualifying quarters, etc. Our team will be able to give you a much more accurate quote on fees after we get some details about your business, and how much work it will be.
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        {/* ------------------------------- F O O T E R -----------------------------------*/}
        <section className='footer quiz-footer'>
            <div className="row p-5 m-0 justify-content-center">
                <div className="col-lg-4 col-md-12 col-sm-12 logo">
                    <img src={logo} alt="logo" className='img-fluid' />
                </div>

                <div className="col-lg-4 col-md-12 col-sm-12">
                    <div className="col-lg-12">
                        <div className="footer-content mb-4">
                            <span>
                                <a href="#" className='mb-4'>Privacy Policy</a>
                                <br />
                                <br />
                                <a href="#" className='mb-4'>Terms and Conditions</a>
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-12 col-sm-12">
                    <div className="col-lg-12">
                        <div className="footer-content">
                            <p>Phone: <a href="tel:+13073126819" style={{ textDecoration: "none", color: "#333333" }}> (307)-312-6819</a></p>
                            <p>Email: service@financialbreed.com</p>
                            <p>© 2022 FinancialBreed – All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
}

export default ResultPage;